import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { CompartmentsSelectionComponent } from './compartments-selection.component';
import { CompartmentsSelectionDialogComponent } from './compartments-dialog/compartments-selection-dialog.component';
import { MatChipsModule } from '@angular/material/chips';
import { ActionButtonComponent, SvgIconComponent } from '../../ui-kit';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { ReactiveFormsModule } from '@angular/forms';
import { AssignableCompartmentListState } from '../../store/state/monitoring/assignable-compartments/assignable-compartments.state';

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatChipsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    ActionButtonComponent,
    MatDialogModule,
    RouterModule,
    NgxsModule.forFeature([AssignableCompartmentListState]),
    TranslateModule.forChild({}),
    SvgIconComponent,
  ],
  exports: [CompartmentsSelectionComponent, CompartmentsSelectionDialogComponent],
  declarations: [CompartmentsSelectionComponent, CompartmentsSelectionDialogComponent],
})
export class CompartmentsSelectionModule {}
